import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/logo.png';
import './CountdownPage.css';

const CountdownPage = () => {
  const navigate = useNavigate();
  const targetDate = new Date('2025-10-24T00:00:00').getTime();

  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    // Countdown timer
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetDate - now;

      if (distance < 0) {
        clearInterval(timer);
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      } else {
        setTimeLeft({
          days: Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((distance % (1000 * 60)) / 1000)
        });
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  const handleOctoberClick = () => {
    setShowButton(true);
  };

   const handleEnter = () => {
  // Mark ceremony as seen
  localStorage.setItem('ceremonySeen', 'true');
  
  // Add celebration flag
  sessionStorage.setItem('showCelebration', 'true');
  
  // Reload to show HomePage
  window.location.href = '/';
};

  return (
    <div className="countdown-page">
      {/* Animated Background */}
      <div className="countdown-bg">
        <div className="floating-particle"></div>
        <div className="floating-particle"></div>
        <div className="floating-particle"></div>
        <div className="floating-particle"></div>
        <div className="floating-particle"></div>
      </div>

      {/* Main Content */}
      <div className="countdown-container">
        
        {/* Logo Section */}
        <div className="logo-section">
          <div className="logo-wrapper">
            <img src={logo} alt="Logo" className="countdown-logo" />
            <div className="logo-glow"></div>
          </div>
        </div>

        {/* Title */}
        <h1 className="countdown-title">
          Something <span className="highlight">Amazing</span> is Coming!
        </h1>
        <p className="countdown-subtitle">
          Join us for a grand celebration on{' '}
          <span 
            className="october-clickable" 
            onClick={handleOctoberClick}
            title="Click to reveal entrance"
          >
            October
          </span>{' '}
          23, 2025
        </p>

        {/* Countdown Timer */}
        <div className="timer-container">
          <div className="timer-box">
            <div className="timer-value">{String(timeLeft.days).padStart(2, '0')}</div>
            <div className="timer-label">Days</div>
          </div>
          <div className="timer-separator">:</div>
          <div className="timer-box">
            <div className="timer-value">{String(timeLeft.hours).padStart(2, '0')}</div>
            <div className="timer-label">Hours</div>
          </div>
          <div className="timer-separator">:</div>
          <div className="timer-box">
            <div className="timer-value">{String(timeLeft.minutes).padStart(2, '0')}</div>
            <div className="timer-label">Minutes</div>
          </div>
          <div className="timer-separator">:</div>
          <div className="timer-box">
            <div className="timer-value">{String(timeLeft.seconds).padStart(2, '0')}</div>
            <div className="timer-label">Seconds</div>
          </div>
        </div>

        {/* Ribbon Button - Only shows after clicking October */}
        {showButton && (
          <div className="ribbon-container">
            <button className="ribbon-button" onClick={handleEnter}>
              <span className="ribbon-text">New Website Launch</span>
              <span className="ribbon-icon">🎉</span>
            </button>
            <div className="ribbon-left"></div>
            <div className="ribbon-right"></div>
          </div>
        )}

        {/* Event Info */}
        <div className="event-info">
          <p className="event-text">
            Shree Swami Samarth Seva Marg<br/>
            <span className="event-highlight">Grand Opening Ceremony</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default CountdownPage;